import { PageController } from '@client/components/_core/layout/PageController';
import { IndicatorReprocessView } from '@client/components/admin-console/IndicatorReprocessView';
import { useTrpc } from '@client/hooks/api/useTrpc';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin-console/advanced/indicators/complaints')({ component: Indicators });

function Indicators() {
    const { trpc } = useTrpc();
    const reprocessComplaintIndicator = trpc.admin.indicator.reprocessComplaintIndicator.useMutation();

    return (
        <PageController route={Route}>
            <IndicatorReprocessView
                entity="complaint"
                idFieldName="complaintId"
                onSubmit={({ orgId, entityId }) =>
                    reprocessComplaintIndicator.mutateAsync({ orgId, complaintId: entityId })
                }
            />
        </PageController>
    );
}
